var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-collapse",
    {
      staticClass: "collapse hiddenScrollbar",
      staticStyle: { width: "100%", padding: "10px" },
      on: { change: _vm.handleChange },
      model: {
        value: _vm.activeNames,
        callback: function ($$v) {
          _vm.activeNames = $$v
        },
        expression: "activeNames",
      },
    },
    [
      _vm.dataList.length === 0
        ? _c("el-empty", {
            staticStyle: { height: "inherit" },
            attrs: { description: "暂无数据" },
          })
        : _vm._l(_vm.dataList, function (item, index) {
            return _c(
              "el-collapse-item",
              { key: "index", attrs: { name: index + "" } },
              [
                _c("template", { slot: "title" }, [
                  _c("div", { staticClass: "TopName" }, [
                    _c("span", { staticClass: "pg" }, [
                      _vm._v(_vm._s(item.resourceName)),
                    ]),
                    _c("span", { staticClass: "sp" }, [
                      _vm._v(_vm._s(item.productName)),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "content" }, [
                  _c(
                    "div",
                    { staticClass: "inst" },
                    [
                      _c("p", { staticClass: "bg" }, [_vm._v("费用说明：")]),
                      _c("p", [
                        _vm._v(
                          _vm._s(item.cityTax) +
                            " " +
                            _vm._s(item.vatTax) +
                            " " +
                            _vm._s(item.breakFast)
                        ),
                      ]),
                      item.freeFacilitiesAndServices.length > 0
                        ? _c("p", { staticClass: "bl" }, [
                            _vm._v("可免费提供的设施及服务为："),
                          ])
                        : _vm._e(),
                      _vm._l(
                        item.freeFacilitiesAndServices,
                        function (freeFacilitiesAndServices, freeIndex) {
                          return _c("p", { key: freeIndex }, [
                            _vm._v(_vm._s(freeFacilitiesAndServices)),
                          ])
                        }
                      ),
                      item.paidFacilitiesAndServices.length > 0
                        ? _c("p", { staticClass: "bl" }, [
                            _vm._v("可有偿提供的设施及服务为："),
                          ])
                        : _vm._e(),
                      _vm._l(
                        item.paidFacilitiesAndServices,
                        function (paidFacilitiesAndServices, paidIndex) {
                          return _c("p", { key: paidIndex }, [
                            _vm._v(_vm._s(paidFacilitiesAndServices)),
                          ])
                        }
                      ),
                    ],
                    2
                  ),
                  item.withdrawalAndModificationMethods.length > 0
                    ? _c(
                        "div",
                        { staticClass: "inst" },
                        [
                          _c("p", { staticClass: "bg" }, [_vm._v("退改方法")]),
                          _vm._l(
                            item.withdrawalAndModificationMethods,
                            function (cancel, cancelIndex) {
                              return _c("p", { key: cancelIndex }, [
                                _vm._v(_vm._s(cancel)),
                              ])
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "inst" }, [
                    item.invoiceDescription
                      ? _c("p", { staticClass: "bl" }, [
                          _vm._v(
                            "发票说明：" + _vm._s(item.invoiceDescription)
                          ),
                        ])
                      : _vm._e(),
                    item.otherInstructions
                      ? _c("p", { staticClass: "bl" }, [
                          _vm._v("其他须知：" + _vm._s(item.otherInstructions)),
                        ])
                      : _vm._e(),
                    item.safetyInstructions
                      ? _c("p", { staticClass: "mp" }, [
                          _vm._v("安全须知:" + _vm._s(item.safetyInstructions)),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ],
              2
            )
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }